import React from 'react';
import GeneralModal from 'components/GeneralModal';
import useModal from '../hooks/useModal';

let ModalContext;
const { Provider } = (ModalContext = React.createContext());

function ModalProvider({ children }) {
  const {
    modal,
    handleModal,
    modalContent,
    hideCloseBtn,
    setHideCloseBtn,
    classes,
    setClasses,
  } = useModal();
  return (
    <Provider
      value={{
        modal,
        handleModal,
        modalContent,
        hideCloseBtn,
        setHideCloseBtn,
        classes,
        setClasses,
      }}
    >
      <GeneralModal />
      {children}
    </Provider>
  );
}

export { ModalContext, ModalProvider };
